// eslint-disable-next-line import/prefer-default-export
export function defaultOnEmpty(object: unknown, defaultVal = undefined): any {
  if (Array.isArray(object)) {
    return object.length === 0 ? defaultVal : object;
  }

  if (typeof object === 'object') {
    if (object === null) {
      return defaultVal;
    }

    const values = Object.values(object);
    if (values.every((v) => v === undefined)) {
      return defaultVal;
    }

    return object;
  }

  if (typeof object === 'string') {
    return object || defaultVal;
  }

  return object;
}
